import React from "react";

function UpdatePopup({
  isOpenModal,
  onCancel,
  onConfirm,
  message,
  selectedLanguage,
  isExpiry,
  handleCloseUpdatePopop
}) {
  if (!isOpenModal) return null; // render nothing if popup not open

  return (
    <div className="child-popup" id="myModal">
      <div className="Settingmodal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* Header */}
          <div
            className="mleft15 d-flex justify-content-between mb-3 modalheaederleft"
            style={{ marginLeft: "9px", marginRight: "0px" }}
          >
            <h4 className="mb-2 mt-2 text-danger fw-bold">
              {selectedLanguage?.LstLanguageCodes?.UI_Update || "Update"}
            </h4>
            {isExpiry == true && (
            <button
              type="button"
              className="btn btn-outline-danger modalclose download"
              onClick={(e) => handleCloseUpdatePopop()}
              style={{top:'10px'}}
            >
              <span className="material-icons font-20">
                highlight_off
              </span>
            </button>
            )}
          </div>

          <hr className="modalhorizontal" />

          {/* Message */}
          <div
            className="d-flex justify-content-center flex-column mb-3 text-center"
            style={{ marginTop: "20px" }}
          >
            <p
              className="w-100 f-w550"
              style={{ display: "content", fontSize: "18px" }}
            >
              {message}
            </p>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-center mb-4">
            <button
              type="button"
              className="btn btn-danger px-4 me-1"
              onClick={onCancel}
            >
              {selectedLanguage?.LstLanguageCodes?.UI_Cancel || "Cancel"}
            </button>
            <button
              type="button"
              className="btn btn-primary px-4 ms-3"
              onClick={onConfirm}
            >
              {isExpiry == true ? "Activate" : selectedLanguage?.LstLanguageCodes?.UI_Confirm || "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdatePopup;
